import React, { createContext, useContext, useState } from "react";
import { Vehicle } from "../CarPartsModule/Types/vehicle";

interface VehicleContextType {
    vehicle: Vehicle | null;
    setVehicle: (vehicle: Vehicle | null) => void;
}

const VehicleContext = createContext<VehicleContextType | undefined>(undefined);

export const VehicleProvider = ({ children }: { children: React.ReactNode; }) => {
    const [vehicle, setVehicle] = useState<Vehicle | null>(null);

    return (
        <VehicleContext.Provider value={{ vehicle, setVehicle }}>
            {children}
        </VehicleContext.Provider>
    );
};

export const useVehicle = () => {
    const ctx = useContext(VehicleContext);
    if (!ctx) {
        throw new Error("useVehicle must be used within VehicleProvider");
    }
    return ctx;
};
